import { FC } from "react";
import { InputField } from "../../../components";

type SummaryReadOnlyFieldProps = {
  label: string;
  tick?: boolean;
  error?: string;
  inputProps: Record<string, any>;
  className?: string;
  inputClassName?: string;
};

export const SummaryReadOnlyField: FC<SummaryReadOnlyFieldProps> = ({
  label,
  tick = false,
  error = "",
  inputProps,
  className = "cx-rounded-lg cx-border-gray-200",
  inputClassName = "cx-rounded-lg cx-bg-gray-100 cx-text-tertiary placeholder:cx-text-tertiary",
}) => (
  <div className="cx-relative cx-w-full">
    <InputField
      label={label}
      inputProps={{ ...inputProps, readOnly: true }}
      tick={tick}
      error={error}
      className={className}
      inputClassName={inputClassName}
      readOnly={true}
    />
  </div>
);

export default SummaryReadOnlyField;
